export default __webpack_public_path__ + "assets/images/b515a8527c054f4bae5a68ef4a02fd77.png";